import React, { useState,useEffect } from 'react';
import Header from './Header';
import Loading from './Loading';
import Inc from './Include';
import './Result.scss';

function Result ({ajax,defaultFace,resultKey,resultHistory,close}){
	const [isLoading,setIsLoading] = useState(false);
	const [face,setFace] = useState(defaultFace);
	const [history,setHistory] = useState([]);

	useEffect( ()=>{
		if( !resultHistory ){
			setIsLoading(true);
			ajax("talk/load",{result_key:resultKey},(res)=>{
				setIsLoading(false);
				if( res.ok ){
					//console.log(res.play);
					setFace(res.play.face);
					setHistory(res.history);
				} else {
					close();
				}
			});
		} else {
			setHistory(resultHistory);
		}
	},[]);

	const talks = history.map( (value,index)=>{
		const key = "key"+index;
		let class1 = "reply";
		let class2 = "fas fa-user-astronaut face";
		if( index%2===1 ){
			class1 = "talk";
			class2 = "fas fa-" + Inc.FACE_ICON[ face-1 ]+" face";
		}
		return (
			<div key={key} className={class1}>
				<i className={class2}></i>
				{value}
			</div>
		)
	});
	let text = "JUNE BEATS YELLOW";
	if( history[0] ){
		text = text+"～"+history[0];
	}
	text = text + " #レトロインク";
	const tweet_url = "https://twitter.com/intent/tweet?url=https%3A%2F%2Fgoisagi.retro-ink.com%2Fyellow%2F"+resultKey+"&text="+encodeURIComponent(text);
	const class0 = "fas fa-" + Inc.FACE_ICON[ face-1 ]+" face";
	return (
		<div id="result" className="panel">
			<Header close={close}/>
			<div className="inner">
				<div className="talk">
					<i className={class0}></i>
					あんた誰？
				</div>
				{talks}
				<div className="end">
					<p>Good Job!!</p>
				</div>
			</div>
			<div className="tweet">
				<a href={tweet_url} target="_blank" className="tw" rel="noopener noreferrer"><span className="fab fa-twitter"></span>ログをツイート</a>
			</div>
			{isLoading &&
			<Loading/>
			}
		</div>
    );
}

export default Result;
